export default __webpack_public_path__ + "static/media/canvasAndFramedLargeCanvas.152a7a77.jpg";